import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerHealthCheckMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('healthChecks', locale)
}
